export default __webpack_public_path__ + "menu-mall-smop-icon.bd93cfe7ef269c8644d00716abaa2b5a.svg";